<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g style="fill:none;stroke-linejoin:round"><path d="m-6357.64-46.367-3.36-2.8-3.36 2.8a1 1 0 0 1-1.641-.768V-59a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v11.864a1 1 0 0 1-1 1 .982.982 0 0 1-.639-.231z" style="stroke:none;fill:none" transform="translate(6369 61)" fill="currentColor"/><path fill="currentColor" d="m-6364.6-47.989 2.704-2.253a1.4 1.4 0 0 1 1.792 0l2.704 2.252V-58.6h-7.2v10.611m-.395 1.856a1 1 0 0 1-1.005-1.003V-59a1 1 0 0 1 1-1h8.001a1 1 0 0 1 .999 1v11.864a1 1 0 0 1-1.64.769l-3.36-2.8-3.36 2.8a.983.983 0 0 1-.635.234z" style="stroke:none" transform="translate(6369 61)"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-bookmark-off',
});
</script>
